var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.activeElement.loading && _vm.activeElement.item)?_c('ExecutingCourseManager',{attrs:{"element":_vm.activeElement.item}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }